import { Card } from "@ziolo/ui";

export function NotFoundPage() {
  return (
    <Card title="Nie znaleziono">
      <p className="hub-hint">
        Taka strona tu nie mieszka.{" "}
        <a href="/">Wróć na zioło.eu</a>
      </p>
    </Card>
  );
}
